// extracted by mini-css-extract-plugin
export var actionButton = "_ov-0";
export var actionMenuContainer = "_ov-i";
export var bubble = "_ov-2";
export var bubbleActionMenu = "_ov-j";
export var bubbleContext = "_ov-6";
export var bubbleItems = "_ov-7";
export var customer = "_ov-3";
export var divider = "_ov-8";
export var fileList = "_ov-9";
export var hiddenComment = "_ov-o";
export var infoAbove = "_ov-a";
export var internal = "_ov-4";
export var lightActionButton = "_ov-1";
export var link = "_ov-b";
export var merchant = "_ov-5";
export var message = "_ov-c";
export var profilePicture = "_ov-e";
export var quillToolbarContainer = "_ov-f";
export var senderDate = "_ov-g";
export var senderDateCustomer = "_ov-h";
export var senderName = "_ov-d";
export var time = "_ov-k";
export var uploadedImage = "_ov-l";
export var username = "_ov-m";
export var xsmall = "_ov-n";